module.exports = __webpack_public_path__ + "img/searchbank.4afc2fa6.svg";